import { List, ListItem, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import dataAtIds from '../../dataAtIds.json';
import ComingSoon from '../ComingSoon/ComingSoon';
import Page from '../Page/Page';
import PageBody from '../Page/PageBody';

const Network: FunctionComponent = () => (
  <Page>
    <PageBody alignChildren="middle">
      <ComingSoon data-trace-at-id={dataAtIds.NetworkPage}>
        <Text margin="x4" weight="bold">
          Monitor your app’s network performance.
        </Text>

        <Text margin="x4">
          <List>
            <ListItem>See the requests your app is making</ListItem>
            <ListItem>Request rate, failure rate and per user rate</ListItem>
            <ListItem>Inspect request details</ListItem>
            <ListItem>Inspect session timeline</ListItem>
          </List>
        </Text>
      </ComingSoon>
    </PageBody>
  </Page>
);

export default Network;
